import React, {Component} from "react";
import {Row, Col, Card, CardBody} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { getInvoices } from "../../store/invoicing/actions";
import {connect} from "react-redux";
import InvoicingList from "./List/getAllInvoicesList";
import Paging from "../../components/Pagination/OldPagination";
import moment from "moment";
import Search from "../../components/Search/Search";
import ListSearch from "components/ListSearch/ListSearch";


class Invoices extends Component {

  constructor(props) {
    super(props);
    this.state = {
      search: {text: '', filter: '', tagsFilters: {}},
      currentPage: 1,
      currentDate: moment(new Date()),
      filterModalOpen: false
    }
    this.options = [
      {keySearch: 'amount', titleSearch: 'Сума'},
      {keySearch: 'professionalID.role', titleSearch: 'Роля на специалиста'},
      {keySearch: 'professionalID.name_professionalID.surname', titleSearch: 'Име на специалист'},
      {keySearch: 'time', titleSearch: 'Дата на фактурата'},
    ]
  }

  componentDidMount() {
    this.props.getInvoices({page: 1});
  }

  setFilterModalOpen = (filterModalOpen) => {
    this.setState({filterModalOpen})
  }

  refreshPage = () => {
    this.setState({search: {filter: '', text: '', tagsFilters: {}}})
    this.props.getInvoices({page: 1});
  }

  setPage = (currentPage) => {
    this.setState({currentPage})
    this.props.getInvoices({page: currentPage});
  }

  onSubmit = (e, search) => {
    e.preventDefault()
    if ((search.text && search.filter) || Object.keys(search.tagsFilters).length) {
      this.props.getInvoices({search, page: 1});
    } else {
      this.props.getInvoices({page: 1});
    }
    this.setState({currentPage: 1, search, filterModalOpen: false})
  }

  handleSearch = (q) => {
    this.setState({currentPage: 1})
    this.props.getInvoices({ q, page: 1 });
  }

  render() {
    const {search, currentPage, filterModalOpen} = this.state;
    const {invoicingList, query} = this.props;
    const q = query?.q;
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Breadcrumbs title="Фактури" breadcrumbItem="Фактури"/>

            <Row>
              <Col>
                <Card>
                  <div className="list-toolbar py-2">
                    <Paging setPage={this.setPage} currentPage={currentPage} pages={invoicingList?.pages}/>

                    <ListSearch
                      value={q || ""}
                      onSearch={this.handleSearch}
                      placeholder="Търсене по специалист"
                    />

                    {/*
                    <Space direction="horizontal" className="mr-4">
                      <Button type={'button'} className='btn btn-info waves-effect waves-light search-btn'
                              onClick={() => this.setFilterModalOpen(!filterModalOpen)}>
                        <i className="bx bx-filter-alt align-middle"></i></Button>
                      {(search.text || Object.keys(search.tagsFilters).length > 0) &&
                        <Button type={'button'} className='btn btn-dark waves-effect waves-light search-btn'
                                onClick={this.refreshPage}><i
                          className='bx bx-revision align-middle'></i></Button>}
                    </Space>
                      */}

                  </div>
                  <CardBody>
                    <InvoicingList
                      list={invoicingList?.payments}
                      onRemoveItem={this.onRemove}
                      onEditItem={this.onEdit}
                      history={this.props.history}
                    />
                  </CardBody>
                  <Paging setPage={this.setPage} currentPage={this.state.currentPage} pages={invoicingList?.pages}/>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <Search searchModalOpen={filterModalOpen}
                options={this.options}
                filterData={['time']}
                searchVar={search}
                tags={invoicingList?.tags}
                onSubmit={this.onSubmit}
                onCancel={() => this.setFilterModalOpen(false)}/>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const {Invoices} = state;
  return Invoices;
};

export default connect(mapStateToProps, {
  getInvoices,
})(Invoices);
